<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>

    <!-- App Selection -->
    <div v-if="isAdmin && hasApps" class="form-group row">
      <label class="col-sm-2 col-form-label" for="app_id">App:</label>
      <div class="col-sm-10">
        <select v-model="selectedAppId" class="form-control" name="app_id">
          <option v-for="app in apps" :key="app.id" :value="app.id">
            {{ app.name }}
          </option>
        </select>
      </div>
    </div>
    <div v-else-if="!isAdmin && appObject" class="form-group row">
      <label class="col-sm-2 col-form-label" for="app_id">App:</label>
      <div class="col-sm-10">
        <input :value="appObject.id" name="app_id" type="hidden"/>
        <input :value="appObject.name" class="form-control" disabled type="text"/>
      </div>
    </div>
    <div v-else class="form-group row">
      <label class="col-sm-2 col-form-label" for="app_id">App:</label>
      <div class="col-sm-10">
        <input name="app_id" type="hidden" value="0"/>
        <input
            class="form-control"
            disabled
            type="text"
            value="keine App mit Punktesystemen gefunden."
        />
      </div>
    </div>

    <!-- Hidden Client ID -->
    <input :value="clientId" name="client_id" type="hidden"/>

    <!-- Hidden Loyalty Setting ID -->
    <input :value="loyaltySettingId" name="loyalty_setting_id" type="hidden"/>

    <div class="hr-line-dashed"></div>

    <!-- Promotion Name -->
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Interner Name:</label>
      <div class="col-sm-10">
        <input
            v-model="localPromotion.name"
            class="form-control m-b"
            name="name"
            type="text"
        />
      </div>
    </div>

    <!-- Promotion Type -->
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Typ:</label>
      <div class="col-sm-10">
        <select
            v-model.number="localPromotion.type"
            class="form-control m-b"
            name="type"
        >
          <option value="1">Zusatzpunkte</option>
          <option value="2">Vervielfachung</option>
        </select>
      </div>
    </div>

    <div class="hr-line-dashed"></div>

    <!-- Multiplier Input -->
    <div v-if="localPromotion.type === 2" class="form-group row">
      <label class="col-sm-2 col-form-label">Wert der Vervielfachung:</label>
      <div class="col-sm-10">
        <select
            v-model.number="localPromotion.multiplier"
            class="form-control m-b"
            name="multiplier"
        >
          <option v-for="n in 9" :key="n" :value="n + 1">
            {{ n + 1 }}-fach
          </option>
        </select>
      </div>
    </div>

    <!-- Bonus Points Inputs -->
    <div v-if="localPromotion.type === 1" class="form-group row">
      <label class="col-sm-2 col-form-label">Ausschüttung bei:</label>
      <div class="col-sm-10">
        <select
            v-model.number="localPromotion.activity"
            class="form-control m-b"
            name="activity"
        >
          <option value="1">App-Registrierung</option>
          <option value="2">App-Aktivierung</option>
        </select>
      </div>
    </div>
    <div v-if="localPromotion.type === 1" class="form-group row">
      <label class="col-sm-2 col-form-label">Anzahl Punkte:</label>
      <div class="col-sm-10">
        <input
            v-model.number="localPromotion.bonus_points"
            class="form-control m-b"
            min="0"
            name="bonus_points"
            type="number"
        />
      </div>
    </div>
    <div v-if="localPromotion.type === 1" class="form-group row">
      <label class="col-sm-2 col-form-label">Gültigkeit der Punkte (in Tagen):</label>
      <div class="col-sm-10">
        <input
            v-model.number="localPromotion.days_available"
            class="form-control m-b"
            min="0"
            name="days_available"
            type="number"
        />
      </div>
    </div>

    <!-- Date/Time Inputs -->
    <div class="form-group row">
      <label class="col-sm-3 col-md-2 col-form-label">Startzeitpunkt:</label>
      <div class="col-sm-9 col-md-10">
        <input
            v-model="localPromotion.start_at"
            class="form-control"
            name="start_at"
            type="datetime-local"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-md-2 col-form-label">Endzeitpunkt:</label>
      <div class="col-sm-9 col-md-10">
        <input
            v-model="localPromotion.end_at"
            class="form-control"
            name="end_at"
            type="datetime-local"
        />
      </div>
    </div>

    <!-- Loyalty Levels Selection with Checkboxes -->
    <div v-if="currentLoyaltyLevels.length > 0" class="form-group row">
      <label class="col-sm-2 col-form-label">Statusgruppen:</label>
      <div class="col-sm-10">
        <!-- "Alle Status Gruppen" checkbox (disabled when activity=1 or 2) -->
        <div>
          <input
              id="status-all"
              v-model="localPromotion.loyalty_level_ids"
              :disabled="forceAllStatuses"
              :value="0"
              name="loyalty_level_ids[]"
              type="checkbox"
          />
          <label for="status-all">Alle Status Gruppen</label>
        </div>
        <!-- Individual Loyalty Levels -->
        <div v-for="level in currentLoyaltyLevels" :key="level.id">
          <input
              :id="'status-' + level.id"
              v-model="localPromotion.loyalty_level_ids"
              :disabled="disableLoyaltyLevels"
              :value="Number(level.id)"
              name="loyalty_level_ids[]"
              type="checkbox"
          />
          <label :for="'status-' + level.id">{{ level.name }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";

export default {
  components: {VueToastr},
  props: {
    loyaltyLevels: {
      type: Array,
      default: () => []
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    apps: {
      type: [Array, Object],
      default: () => null
    },
    promotion: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      localPromotion: {
        name: "",
        type: 1,
        multiplier: 2,
        bonus_points: 0,
        activity: 1,
        start_at: "",
        end_at: "",
        loyalty_level_ids: [],
        days_available: 0
      },
      selectedAppId: null,
      disableLoyaltyLevels: false,
      originalAppId: null
    };
  },
  computed: {
    hasApps() {
      return Array.isArray(this.apps) && this.apps.length > 0;
    },
    appObject() {
      return !Array.isArray(this.apps) ? this.apps : null;
    },
    clientId() {
      if (this.selectedAppId && Array.isArray(this.apps)) {
        const selectedApp = this.apps.find(
            (app) => app.id === this.selectedAppId
        );
        return selectedApp ? selectedApp.client_id : null;
      }
      if (this.appObject) {
        return this.appObject.client_id;
      }
      return null;
    },
    loyaltySettingId() {
      if (this.selectedAppId && Array.isArray(this.apps)) {
        const selectedApp = this.apps.find(
            (app) => app.id === this.selectedAppId
        );
        return selectedApp ? selectedApp.loyalty_setting_id : null;
      }
      if (this.appObject) {
        return this.appObject.loyalty_setting_id;
      }
      return null;
    },
    currentLoyaltyLevels() {
      if (this.selectedAppId && Array.isArray(this.apps)) {
        const selectedApp = this.apps.find(
            (app) => app.id === this.selectedAppId
        );
        return selectedApp && selectedApp.loyalty_levels
            ? selectedApp.loyalty_levels
            : [];
      }
      if (this.appObject && this.appObject.loyalty_levels) {
        return this.appObject.loyalty_levels;
      }
      return this.loyaltyLevels;
    },
    forceAllStatuses() {
      return (
          this.localPromotion.type === 1 &&
          (this.localPromotion.activity === 1 || this.localPromotion.activity === 2)
      );
    }
  },
  watch: {
    "localPromotion.type"(newType) {
      this.localPromotion.loyalty_level_ids = [];
      this.disableLoyaltyLevels = false;
      if (newType === 2) {
        this.localPromotion.bonus_points = 0;
        this.localPromotion.days_available = 0;
        if (!this.localPromotion.multiplier) {
          this.localPromotion.multiplier = 2;
        }
      } else if (newType === 1) {
        this.localPromotion.multiplier = 2;
      }
    },
    selectedAppId(newId) {
      if (this.originalAppId !== null && newId === this.originalAppId) {
        return;
      }
      this.localPromotion.loyalty_level_ids = [];
      this.disableLoyaltyLevels = false;
    },
    "localPromotion.activity"(newActivity) {
      if (this.forceAllStatuses) {
        const allIds = this.currentLoyaltyLevels.map((lvl) => Number(lvl.id));
        this.localPromotion.loyalty_level_ids = [0, ...allIds];
        this.disableLoyaltyLevels = true;
      } else {
        this.localPromotion.loyalty_level_ids = [];
        this.disableLoyaltyLevels = false;
      }
    },

    "localPromotion.loyalty_level_ids": {
      handler(newVal) {
        if (this.forceAllStatuses) {
          return;
        }

        if (newVal.length === 0) {
          this.disableLoyaltyLevels = false;
          return;
        }
        if (newVal.includes(0)) {
          this.disableLoyaltyLevels = true;
          const allIds = this.currentLoyaltyLevels.map((level) =>
              Number(level.id)
          );
          const desired = [0, ...allIds];
          const numeric = newVal.map((id) => Number(id));
          const same =
              numeric.length === desired.length &&
              numeric.every((v, i) => v === desired[i]);
          if (!same) {
            this.localPromotion.loyalty_level_ids = desired;
          }
        } else {
          this.disableLoyaltyLevels = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    formatDateTimeForInput(dt) {
      if (!dt) return "";
      const d = new Date(dt);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
  },
  mounted() {
    if (this.promotion) {
      this.localPromotion = {...this.promotion};
      this.localPromotion.start_at = this.formatDateTimeForInput(
          this.promotion.start_at
      );
      this.localPromotion.end_at = this.formatDateTimeForInput(
          this.promotion.end_at
      );

      if (typeof this.promotion.days_available !== "undefined") {
        this.localPromotion.days_available = Number(this.promotion.days_available);
      } else {
        this.localPromotion.days_available = 0;
      }

      if (this.promotion.app_id) {
        this.selectedAppId = this.promotion.app_id;
        this.originalAppId = this.promotion.app_id;
      }

      if (Array.isArray(this.promotion.loyalty_level_ids)) {
        this.localPromotion.loyalty_level_ids = this.promotion.loyalty_level_ids.map(
            (id) => Number(id)
        );
      } else {
        this.localPromotion.loyalty_level_ids = [];
      }

      if (
          this.localPromotion.type === 1 &&
          (this.localPromotion.activity === 1 ||
              this.localPromotion.activity === 2)
      ) {
        const allIds = this.currentLoyaltyLevels.map((lvl) => Number(lvl.id));
        this.localPromotion.loyalty_level_ids = [0, ...allIds];
        this.disableLoyaltyLevels = true;
      }
    } else if (this.isAdmin && this.hasApps) {
      this.selectedAppId = this.apps[0].id;
    }
  }
};
</script>
